export {default} from './TipCardList';


// WEBPACK FOOTER //
// ./src/app/intro/components/TipCardList/index.js